import { resourceExplorerDataSelector } from "./resourceExplorerDataSelector";
import { RootState } from "@/store/store";

export const resourceExplorerCostTypeSelector = (state: RootState) => {
  const data = resourceExplorerDataSelector(state);

  return data?.cost_type;
};
